export default "__VITE_PUBLIC_ASSET__ed2cb852__"